// // import React from "react";
// // import { Routes, Route, Link } from "react-router-dom";
// // import MainPage from "./pages/MainPage";
// // import InpaintingPage from "./pages/inpaintingpage";
// // import FurnishingPage from "./pages/FurnishingPage";
// // import "./App.css";
// // import Login from "./components/login";
// // import Signup from "./components/Signup";
// // import ExploreToolsPage from "./pages/ToolsSection"; // Import the component

// // function App() {
// //   return (
// //     <Routes>
// //       <Route path="/" element={
// //         <div className="home-wrapper">
// //           <header className="navbarhome">
// //             <h1>
// //              <a href="/#home" className="logo">RevampSpaces</a>
// //             </h1>
// //             <div className="navbar-links">
// //               <a href="/#about" className="nav-link">About Us</a>
// //               <a href="/#contact" className="nav-link">Contact Us</a>
// //               <Link to="/login" className="nav-link">Login</Link>
// //               {/* <Link to="/signup" className="nav-link">Signup</Link> */}
// //             </div>
// //           </header>
// //           <HomePage />
// //         </div>
// //       } />
// //       {/* <Route path="/RevampSpaces-ai" element={
// //         <div className="home-wrapper">
// //           <header className="navbarhome">
// //             <h1>RevampSpaces</h1>
// //             <div className="navbar-links">
// //               <Link to="/" className="nav-link">Home</Link>
// //               <Link to="/#about" className="nav-link">About Us</Link>
// //               <Link to="/#contact" className="nav-link">Contact Us</Link>
// //               <Link to="/login" className="nav-link">Login</Link>
// //               <Link to="/signup" className="nav-link">Signup</Link>
// //             </div>
// //           </header>
// //           <HomePage />
// //         </div>
// //       } /> */}
// //       <Route path="/main" element={<MainPage />} />
// //       <Route path="/inpainting" element={<InpaintingPage />} />
// //       <Route path="/furnish" element={<FurnishingPage />} />
// //       <Route path="/signup" element={<Signup />} />
// //       <Route path="/login" element={<Login />} />
// //       <Route path="/tools" element={<ExploreToolsPage />} /> 
// //     </Routes>
// //   );
// // }

// // function HomePage() {
// //   return (
// //     <div className="homepage" id="home">
// //       {/* Hero Section */}
// //       <header className="hero" style={{ 
// //         backgroundImage: `url(${process.env.PUBLIC_URL}/images/backimg2.png)`,
// //         backgroundSize: 'cover', 
// //         backgroundPosition: 'center' 
// //       }}>
// //         <div className="hero-content">
// //           <div className="hero-card">
// //             <h1>Revamp Your Space with AI</h1>
// //             <p>Transform your interiors effortlessly with AI-powered design tools.</p>
// //             <Link to="/login" className="cta-button">Get Started</Link>
// //           </div>
// //         </div>
// //       </header>

// //       {/* Why Choose Us Section */}
// //       <section className="why-choose-us">
// //           <div className="animated-bg">
// //             <div className="circle circle1"></div>
// //             <div className="circle circle2"></div>
// //             <div className="circle circle3"></div>
// //             <div className="circle circle4"></div>
// //             <div className="circle circle5"></div>
// //             <div className="circles circles1"></div>
// //             <div className="circless circles2"></div>
// //           </div>

// //           <h2>Why Choose RevampSpaces?</h2>
// //           <h3>Intelligent. Seamless. Affordable. Your dream space is just a click away.</h3>
// //           <div className="card-container">
// //             <div className="card">
// //               <h3>AI-Powered Precision</h3>
// //               <p>Our advanced AI understands spatial aesthetics, color harmony, and design principles—delivering interiors that feel expertly curated. Every generated space is crafted with precision, ensuring a seamless blend of beauty and functionality</p>
// //             </div>
// //             <div className="card">
// //               <h3>Quick & Easy</h3>
// //               <p>No design expertise? No problem. Our platform is built for everyone—just upload, select, and transform. With an intuitive interface and smart automation, creating breathtaking interiors has never been easier.</p>
// //             </div>
// //             <div className="card">
// //               <h3>Budget-Friendly</h3>
// //               <p>Great design shouldn’t come with a hefty price tag. Whether you're exploring concepts or finalizing a vision, RevampSpaces helps you achieve stunning interiors without overspending. Experience high-end aesthetics tailored to your budget.</p>
// //             </div>
// //           </div>
// //       </section>

// //       {/* About Section */}
// //       <section id="about" className="about-section">
// //         <div className="animated-bgas"> {/* This will hold the moving shapes */}
// //             {/* <div className="circle circle1"></div>
// //             <div className="circle circle2"></div>
// //             <div className="circle circle3"></div>
// //             <div className="circle circle4"></div>
// //             <div className="circle circle5"></div> */}
// //             <div className="circlesas circles1as"></div>
// //             <div className="circlessas circles2as"></div>
// //         </div>
// //         <div className="about-container">
// //           {/* Left Side - Text */}
// //           <div className="about-text">
// //             <h2>About Us</h2>
// //             <p>
// //               At <strong>RevampSpaces</strong>, we believe that interior design should be effortless, 
// //               accessible, and inspiring. Our AI-powered platform transforms the way you design your space, 
// //               allowing you to visualize stunning interiors with just a few clicks. 
// //             </p>
// //             <p>
// //               Whether you're refreshing a single room or revamping your entire home, 
// //               our intelligent tools generate personalized designs tailored to your style and preferences.  
// //             </p>
// //           </div>

// //           {/* Right Side - Image */}
// //           <div className="about-image">
// //             <img src={`${process.env.PUBLIC_URL}/images/farmhouse.png`} alt="About Us" />
// //           </div>
// //         </div>
// //       </section>


// //       <section className="gallery">
// //         <div className="animated-bggi"> {/* This will hold the moving shapes */}
// //             {/* <div className="circle circle1"></div>
// //             <div className="circle circle2"></div>
// //             <div className="circle circle3"></div>
// //             <div className="circle circle4"></div>
// //             <div className="circle circle5"></div> */}
// //             <div className="circlesgi circles1gi"></div>
// //             <div className="circlessgi circles2gi"></div>
// //         </div>
// //         <h2>Our Generated Images</h2>
// //         <div className="gallery-container">
// //           <div className="gallery-track">
// //             <img src={`${process.env.PUBLIC_URL}/images/image1.png`} alt="Gallery Image 1"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image2.png`} alt="Gallery Image 2"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image3.png`} alt="Gallery Image 3"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image4.png`} alt="Gallery Image 4"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image5.png`} alt="Gallery Image 5"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image1.png`} alt="Gallery Image 1"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image2.png`} alt="Gallery Image 2"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image3.png`} alt="Gallery Image 3"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image4.png`} alt="Gallery Image 4"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image5.png`} alt="Gallery Image 5"/>
// //           </div>
// //         </div>
// //       </section>

// //       <section className="gallery2">
// //         <div className="animated-bggii"> {/* This will hold the moving shapes */}
// //             <div className="circlegii circle1gii"></div>
// //             <div className="circlegii circle2gii"></div>
// //             <div className="circlegii circle3gii"></div>
// //             <div className="circlegii circle4gii"></div>
// //             <div className="circlegii circle5gii"></div>
// //             <div className="circlesgii circles1gii"></div>
// //             <div className="circlessgii circles2gii"></div>
// //         </div>
// //         <div className="gallery-container2">
// //           <div className="gallery-track2">
// //             <img src={`${process.env.PUBLIC_URL}/images/image6.png`} alt="Gallery Image 6"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image7.png`} alt="Gallery Image 7"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image8.png`} alt="Gallery Image 8"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image9.png`} alt="Gallery Image 9"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image10.png`} alt="Gallery Image 10"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image11.png`} alt="Gallery Image 11"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image12.png`} alt="Gallery Image 12"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image6.png`} alt="Gallery Image 6"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image7.png`} alt="Gallery Image 7"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image8.png`} alt="Gallery Image 8"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image9.png`} alt="Gallery Image 9"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image10.png`} alt="Gallery Image 10"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image11.png`} alt="Gallery Image 11"/>
// //             <img src={`${process.env.PUBLIC_URL}/images/image12.png`} alt="Gallery Image 12"/>
// //           </div>
// //         </div>
// //       </section>


// //       {/* Types of Images We Work With Section */}
// //       <section className="image-types">
// //         <div className="animated-bgit"> {/* This will hold the moving shapes */}
// //             <div className="circleit circle1it"></div>
// //             <div className="circleit circle2it"></div>
// //             <div className="circleit circle3it"></div>
// //             <div className="circleit circle4it"></div>
// //             <div className="circleit circle5it"></div>
// //             <div className="circlesit circles1it"></div>
// //             <div className="circlessit circles2it"></div>
// //         </div>
// //         <h2>Types of Images We Work With</h2>
// //         <div className="image-grid">
// //           {/* First Image Card */}
// //           <div className="image-card">
// //             <div className="hover-image">
// //               <img src={`${process.env.PUBLIC_URL}/images/livingroom1.jpg`} alt="Simple Room Before" className="before" />
// //               <img src={`${process.env.PUBLIC_URL}/images/livingroom.png`} alt="Simple Room After" className="after" />
// //             </div>
// //             <div className="card-content">
// //               <h3>Revamp Your Space With A Click</h3>
// //               <p>Imagine capturing a photo of your room and instantly exploring a world of design possibilities. At RevampSpaces, we bring your interiors to life with the power of AI. Simply upload an image of your space, and our advanced technology will generate stunning redesigns tailored to your preferred style—whether it’s modern minimalism, cozy Scandinavian, or luxurious contemporary.</p>
// //             </div>
// //           </div>

// //           {/* Second Image Card */}
// //           <div className="image-card">
// //             <div className="hover-image">
// //               <img src={`${process.env.PUBLIC_URL}/images/bathroom.jpg`} alt="Sketch Before" className="before" />
// //               <img src={`${process.env.PUBLIC_URL}/images/bathroom1.png`} alt="Sketch After" className="after" />
// //             </div>
// //             <div className="card-content">
// //               <h3>From Sketch to Stunning Interior</h3>
// //               <p>A simple sketch is all it takes to bring your vision to life. With RevampSpaces, transform hand-drawn layouts into beautifully designed interiors in seconds. Whether it’s a rough outline or a detailed floor plan, our AI interprets your ideas and reimagines them in breathtaking styles.</p>
// //             </div>
// //           </div>

// //           {/* Third Image Card */}
// //           <div className="image-card">
// //             <div className="hover-image">
// //               <img src={`${process.env.PUBLIC_URL}/images/tvpanel1.png`} alt="3D Model Before" className="before" />
// //               <img src={`${process.env.PUBLIC_URL}/images/tvpanel.png`} alt="3D Model After" className="after" />
// //             </div>
// //             <div className="card-content">
// //               <h3>From 3D Model to Breathtaking Design</h3>
// //               <p>Bring your 3D models to life with stunning interior designs. At RevampSpaces, our AI transforms basic 3D layouts into fully styled, photorealistic interiors. Simply upload your model, select a theme, and watch as your space evolves with elegance and precision.</p>
// //             </div>
// //           </div>

// //           <div className="image-card">
// //             <div className="hover-image">
// //               <img src={`${process.env.PUBLIC_URL}/images/emptyroom.png`} alt="Simple Room Before" className="before" />
// //               <img src={`${process.env.PUBLIC_URL}/images/emptyroom1.png`} alt="Simple Room After" className="after" />
// //             </div>
// //             <div className="card-content">
// //               <h3>Turn bare walls into beautiful homes—one piece at a time.</h3>
// //               <p>An empty room is a canvas full of possibilities. With RevampSpaces, effortlessly fill your space with carefully curated furniture and decor, perfectly tailored to your style. From sleek modern aesthetics to timeless classics, our AI places each piece with harmony and precision—transforming emptiness into elegance.</p>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Do It Yourself */}
// //       <div className="how-it-works">
// //         <div className="animated-bghiw"> {/* This will hold the moving shapes */}
// //             <div className="circlehiw circle1hiw"></div>
// //             <div className="circlehiw circle2hiw"></div>
// //             <div className="circlehiw circle3hiw"></div>
// //             <div className="circlehiw circle4hiw"></div>
// //             <div className="circlehiw circle5hiw"></div>
// //             <div className="circleshiw circles1hiw"></div>
// //             <div className="circlesshiw circles2hiw"></div>
// //         </div>
// //         <h2>Do It Yourself</h2>
// //         <div className="card-container">
// //           <div className="card">
// //             <h3>Step 1: Upload Your Room</h3>
// //             <p>Simply upload a picture of your room, and we'll take care of the rest!</p>
// //             <img src={`${process.env.PUBLIC_URL}/images/uploadicon.png`} alt="Upload Icon" className="before" />
// //           </div>
// //           <div className="card">
// //             <h3>Step 2: Select Your Style</h3>
// //             <p>Choose your favorite interior design style and let us create the perfect look for you.</p>
// //             <img src={`${process.env.PUBLIC_URL}/images/styles.png`} alt="Style Selection" className="before" />
// //             <img src={`${process.env.PUBLIC_URL}/images/rooms.png`} alt="Room Types" className="after" />
// //           </div>
// //           <div className="card">
// //             <h3>Step 3: Receive Your Design</h3>
// //             <p>Get your personalized design suggestions, ready to transform your space!</p>
// //             <img src={`${process.env.PUBLIC_URL}/images/bedroom.png`} alt="Bedroom Design" className="after" />
// //           </div>
// //         </div>
// //       </div>

// //       {/* <section className="how-it-works">
// //         <h2>Do It Yourself</h2>
// //           <div className="how-it-works-card-container">
// //             <div className="how-it-works-card">
// //                <h3>Step 1: Upload Your Room</h3>
// //                 <p>Simply upload a picture of your room, and we'll take care of the rest!</p>
// //                <img src="/images/uploadicon.png" alt="Simple Room Before" className="before" />
// //             </div>
// //             <div className="how-it-works-card">
// //               <h3>Step 2: Select Your Style</h3>
// //               <p>Choose your favorite interior design style and let us create the perfect look for you.</p>
// //               <img src="/images/styles.png" alt="Simple Room Before" className="before" />
// //             </div>
// //             <div className="how-it-works-card">
// //               <h3>Step 3: Receive Your Design</h3>
// //               <p>Get your personalized design suggestions, ready to transform your space!</p>
// //               <img src="/images/bedroom.png" alt="Simple Room Before" className="before" />
// //             </div>
// //           </div>
// //       </section> */}


// //       {/* Features Section */}
// //       {/* <section className="features">
// //       <div className="animated-bgfs"> 
// //             <div className="circlefs circle1fs"></div>
// //             <div className="circlefs circle2fs"></div>
// //             <div className="circlefs circle3fs"></div>
// //             <div className="circlefs circle4fs"></div>
// //             <div className="circlefs circle5fs"></div>
// //             <div className="circlesfs circles1fs"></div>
// //             <div className="circlessfs circles2fs"></div>
// //         </div>
// //         <h2>Explore Our Tools</h2>
// //         <div className="card-container">
// //           <Link to="/main" className="card">
// //             <h3>Text to Image</h3>
// //             <p>Generate interior designs from text prompts.</p>
// //           </Link>
// //           <Link to="/furnish" className="card">
// //             <h3>Turn bare walls into beautiful homes—one piece at a time.</h3>
// //             <p>Edit and enhance existing interior images.</p>
// //           </Link>
// //         </div>
// //       </section> */}

// //       {/* Upcoming Tools Section */}
// //       {/* <section className="upcoming-tools">
// //         <h2>Upcoming Tools</h2>
// //         <div className="card-container">
// //           <div className="card">
// //             <h3>Floor Planner to 3D</h3>
// //             <p>Generate floor plans from text or images.</p>
// //             <img src={`${process.env.PUBLIC_URL}/images/floorplan.jpg`} alt="Floor Planner to 3D" className="card-image" />
// //           </div>
// //           <div className="card">
// //             <h3>3D Room Visualization</h3>
// //             <p>View your designs in a 3D environment.</p>
// //             <img src="image1.jpg" alt="Floor Planner to 3D" className="card-image" />
// //           </div>
// //           <div className="card">
// //             <h3>Custom Designs</h3>
// //             <p>Personalized interior AI models for designers to ease their workload.</p>
// //             <img src="image1.jpg" alt="Floor Planner to 3D" className="card-image" />
// //           </div>
// //           <div className="card">
// //             <h3>Furniture selection</h3>
// //             <p>Use products available in you nearby shops in you image to understand if it looks good or not and buy them</p>
// //             <img src="image1.jpg" alt="Floor Planner to 3D" className="card-image" />
// //           </div>
// //         </div>
// //       </section> */}


// //       <section className="upcoming-tools">
// //         <div className="animated-bgut"> {/* This will hold the moving shapes */}
// //             <div className="circleut circle1ut"></div>
// //             <div className="circleut circle2ut"></div>
// //             <div className="circleut circle3ut"></div>
// //             <div className="circleut circle4ut"></div>
// //             <div className="circleut circle5ut"></div>
// //             <div className="circlesut circles1ut"></div>
// //             <div className="circlessut circles2ut"></div>
// //         </div>
// //         <h2>Upcoming Tools</h2>
// //         <div className="card-container">
// //           {/* First Image Card */}
// //           <div className="image-card">
// //             <div className="hover-image">
// //               <img src={`${process.env.PUBLIC_URL}/images/2dfloorplan.png`} alt="Simple Room Before" className="before" />
// //               <img src={`${process.env.PUBLIC_URL}/images/3dfloorplan.jpg`} alt="Simple Room After" className="after" />
// //             </div>
// //             <div className="card-content">
// //               <h3>From 2D Plans to 3D Spaces In Minutes</h3>
// //               <h4>Visualize Before You Create.</h4>
// //               <p>Transform your 2D floor plans into simple, structured 3D models with ease. At RevampSpaces, we bridge the gap between sketches and stunning interiors by generating basic 3D layouts that serve as the foundation for AI-powered design transformations.</p>
// //             </div>
// //           </div>

// //           <div className="image-card">
// //             <div className="hover-image">
// //               <img src={`${process.env.PUBLIC_URL}/images/theme1.png`} alt="Simple Room Before" className="before" />
// //               <img src={`${process.env.PUBLIC_URL}/images/theme2.png`} alt="Simple Room After" className="after" />
// //             </div>
// //             <div className="card-content">
// //               <h3>Bespoke AI Models, Tailored to Your Vision</h3>
// //               <h4>Your Style. Your AI. Your Legacy.</h4>
// //               <p>At RevampSpaces, we offer an exclusive service for designers, brands, and artists looking to train AI models on their unique design styles. Whether you’re an interior designer, an architect, or a creative visionary, our AI can learn from your work—capturing your signature aesthetic and transforming it into a tool that scales your creativity.</p>
// //             </div>
// //           </div>

// //           {/* Second Image Card */}
// //           <div className="image-card">
// //             <div className="hover-image">
// //               <img src={`${process.env.PUBLIC_URL}/images/bedroom_chair0.png`} alt="Sketch Before" className="before" />
// //               <img src={`${process.env.PUBLIC_URL}/images/bedroom_chair2.png`} alt="Sketch After" className="after" />
// //             </div>
// //             <div className="card-content">
// //               <h3>Experience the Future of Interior Shopping</h3>
// //               <h4>See it. Style it. Shop it.</h4>
// //               <p>At RevampSpaces, we’re not just transforming interiors—we’re revolutionizing the way you shop for furniture. Soon, our platform will evolve into a dynamic marketplace, where you can generate and visualize furniture from nearby stores directly in your space.</p>
// //             </div>
// //           </div>

// //           {/* Third Image Card */}
// //           {/* <div className="image-card">
// //             <div className="hover-image">
// //               <img src={`${process.env.PUBLIC_URL}/images/tvpanel1.png`} alt="3D Model Before" className="before" />
// //               <img src={`${process.env.PUBLIC_URL}/images/tvpanel.png`} alt="3D Model After" className="after" />
// //             </div>
// //             <div className="card-content">
// //               <h3></h3>
// //               <p>This is the description for the third card. The image and text are placed in an alternating layout.</p>
// //             </div>
// //           </div> */}
// //         </div>
// //       </section>

// //       {/* Pricing Section */}
// //       <section id="pricing" className="pricing">
// //       <div className="animated-bgp"> {/* This will hold the moving shapes */}
// //             <div className="circlessp circles2p"></div>
// //         </div>
// //         <h2>Pricing</h2>
// //         <div className="price-card">
// //           <h3>Basic (5 credits)</h3>
// //           <p>Free for 5 image generations</p>
// //           <p>Get basic AI-generated designs.</p>
// //           <p>Only image generations</p>
// //           <div className="comingsoon">
// //             <h3>Coming Soon</h3>
// //           </div>
// //         </div>
// //         <div className="price-card">
// //           <h3>Weekly</h3>
// //           <p>600/week (150 credits) </p>
// //           <p>For a week you can generate upto 150 images</p>
// //           <p>Only image generations</p>
// //           <div className="comingsoon">
// //             <h3>Coming Soon</h3>
// //           </div>
// //         </div>
// //         <div className="price-card">
// //           <h3>Monthly</h3>
// //           <p>2000/month (500 credits) </p>
// //           <p>for a Month you can generate 500 images</p>
// //           <p>Only image generations</p>
// //           <div className="comingsoon">
// //             <h3>Coming Soon</h3>
// //           </div>
// //         </div>
// //         <div className="price-card">
// //           <h3>Pro</h3>
// //           <p>5000/month (1000 credits) </p>
// //           <p>for a Month you can generate 1000 images</p>
// //           <p>Access to all tools</p>
// //           <div className="comingsoon">
// //             <h3>Coming Soon</h3>
// //           </div>
// //         </div>
// //       </section>

// //       {/* FAQ Section */}
// //       <section id="faq" className="faq">
// //       <div className="animated-bgfaq"> {/* This will hold the moving shapes */}
// //             <div className="circlessfaq circles2faq"></div>
// //         </div>
// //         <h2>Frequently Asked Questions</h2>
// //         <div className="faq-item">
// //           <h3>How does it work?</h3>
// //           <p>Upload a photo, select a style, and receive a design.</p>
// //         </div>
// //         <div className="faq-item">
// //           <h3>Is it free to use?</h3>
// //           <p>We offer a free basic version and a paid pro plan.</p>
// //         </div>
// //       </section>

// //       {/* Contact Section */}
// //       <section id="contact" className="contact">
// //       <div className="animated-bgc"> {/* This will hold the moving shapes */}
// //         <div className="circlessc circles2c"></div>
// //       </div>
// //        <h2>Contact Us</h2>
// //        <p>Email: support@revampspaces.com</p>
// //   {/* Social Media Links */}
// //         <div className="social-links">
// //          <a href="https://www.instagram.com/revampspaces.in" target="_blank" rel="noopener noreferrer">
// //           <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" className="social-icon" />
// //          </a>
// //         </div>
// //       </section>


// //       {/* Footer Section */}
// //       <footer className="footer">
// //         <p>© 2025 RevampSpaces | AI-Powered Interior Design</p>
// //       </footer>
// //     </div>
// //   );
// // }

// // export default App;

// import React, { useEffect, useState } from "react";
// import { Routes, Route, Link } from "react-router-dom";
// import MainPage from "./pages/MainPage";
// import InpaintingPage from "./pages/inpaintingpage";
// import FurnishingPage from "./pages/FurnishingPage";
// import "./App1.css";
// import Login from "./components/login";
// import Signup from "./components/Signup";
// import ExploreToolsPage from "./pages/ToolsSection";
// // import { onAuthStateChanged } from "firebase/auth";
// // import { auth } from "./components/firebase";

// function App() {
//   const [menuActive, setMenuActive] = useState(false);
//   // const [user, setUser] = useState(null);

//   // useEffect(() => {
//   //   const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
//   //     if (firebaseUser) {
//   //       setUser(firebaseUser);
//   //       console.log("User is logged in:", firebaseUser.email);
//   //     } else {
//   //       setUser(null);
//   //       console.log("No user logged in");
//   //     }
//   //   });

//   //   return () => unsubscribe();
//   // }, []);

//   const toggleMenu = () => {
//     setMenuActive(!menuActive);
//   };

//   useEffect(() => {
//     const navbar = document.querySelector(".navbarhome");
//     const handleScroll = () => {
//       if (window.scrollY > 50) {
//         navbar.classList.add("sticky");
//       } else {
//         navbar.classList.remove("sticky");
//       }
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <Routes>
//       <Route path="/" element={
//         <div className="home-wrapper">
//           <header className="navbarhome">
//             <h1>
//               <a href="/#home" className="logo">RevampSpaces</a>
//             </h1>
//             <div className={`navbar-links ${menuActive ? 'active' : ''}`}>
//               <a href="/#about" className="nav-link" onClick={() => setMenuActive(false)}>About Us</a>
//               <a href="/#contact" className="nav-link" onClick={() => setMenuActive(false)}>Contact Us</a>
//               <Link to="/login" className="nav-link" onClick={() => setMenuActive(false)}>Login</Link>
//             </div>
//             <div className={`hamburger ${menuActive ? 'active' : ''}`} onClick={toggleMenu}>
//               <span></span>
//               <span></span>
//               <span></span>
//             </div>
//           </header>
//           <HomePage />
//         </div>
//       } />
//       <Route path="/main" element={<MainPage />} />
//       <Route path="/inpainting" element={<InpaintingPage />} />
//       <Route path="/furnish" element={<FurnishingPage />} />
//       <Route path="/signup" element={<Signup />} />
//       <Route path="/login" element={<Login />} />
//       <Route path="/tools" element={<ExploreToolsPage />} />
//     </Routes>
//   );
// }

// function HomePage() {
//   return (
//     <div className="homepage" id="home">
//       {/* Hero Section */}
//       <header className="hero" style={{ 
//         backgroundImage: `url(${process.env.PUBLIC_URL}/images/backimg2.png)`,
//         backgroundSize: 'cover', 
//         backgroundPosition: 'center' 
//       }}>
//         <div className="hero-content">
//           <div className="hero-card">
//             <h1>Revamp Your Space with AI</h1>
//             <p>Transform your interiors effortlessly with AI-powered design tools.</p>
//             <Link to="/login" className="cta-button">Get Started</Link>
//           </div>
//         </div>
//       </header>

//       {/* Why Choose Us Section */}
//       <section className="why-choose-us">
//           {/* <div className="animated-bg">
//             <div className="circle circle1"></div>
//             <div className="circle circle2"></div>
//             <div className="circle circle3"></div>
//             <div className="circle circle4"></div>
//             <div className="circle circle5"></div>
//             <div className="circles circles1"></div>
//             <div className="circless circles2"></div>
//           </div> */}

//           <h2>Why Choose RevampSpaces?</h2>
//           <h3>Intelligent. Seamless. Affordable. Your dream space is just a click away.</h3>
//           <div className="card-container">
//             <div className="card">
//               <h3>AI-Powered Precision</h3>
//               <p>Our advanced AI understands spatial aesthetics, color harmony, and design principles—delivering interiors that feel expertly curated. Every generated space is crafted with precision, ensuring a seamless blend of beauty and functionality</p>
//             </div>
//             <div className="card">
//               <h3>Quick & Easy</h3>
//               <p>No design expertise? No problem. Our platform is built for everyone—just upload, select, and transform. With an intuitive interface and smart automation, creating breathtaking interiors has never been easier.</p>
//             </div>
//             <div className="card">
//               <h3>Budget-Friendly</h3>
//               <p>Great design shouldn't come with a hefty price tag. Whether you're exploring concepts or finalizing a vision, RevampSpaces helps you achieve stunning interiors without overspending. Experience high-end aesthetics tailored to your budget.</p>
//             </div>
//           </div>
//       </section>

//       {/* About Section */}
//       <section id="about" className="about-section">
//         {/* <div className="animated-bgas">
//             <div className="circlesas circles1as"></div>
//             <div className="circlessas circles2as"></div>
//         </div> */}
//         <div className="about-container">
//           <div className="about-text">
//             <h2>About Us</h2>
//             <p>
//               At <strong>RevampSpaces</strong>, we believe that interior design should be effortless, 
//               accessible, and inspiring. Our AI-powered platform transforms the way you design your space, 
//               allowing you to visualize stunning interiors with just a few clicks. 
//             </p>
//             <p>
//               Whether you're refreshing a single room or revamping your entire home, 
//               our intelligent tools generate personalized designs tailored to your style and preferences.  
//             </p>
//           </div>
//           <div className="about-image">
//             {/* <img src={`${process.env.PUBLIC_URL}/images/farmhouse.png`} alt="About Us" /> */}
//             <video 
//                src={`${process.env.PUBLIC_URL}/videos/about.mp4`} 
//                autoPlay 
//                loop 
//                muted 
//                playsInline
//                className="about-video"
//             />
//           </div>
//         </div>
//       </section>

//       <section className="gallery">
//         {/* <div className="animated-bggi">
//             <div className="circlesgi circles1gi"></div>
//         </div> */}
//         <h2>Our Generated Images</h2>
//         <div className="gallery-container">
//           <div className="gallery-track">
//             <img src={`${process.env.PUBLIC_URL}/images/image1.png`} alt="Gallery Image 1"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image2.png`} alt="Gallery Image 2"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image3.png`} alt="Gallery Image 3"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image4.png`} alt="Gallery Image 4"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image5.png`} alt="Gallery Image 5"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image1.png`} alt="Gallery Image 1"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image2.png`} alt="Gallery Image 2"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image3.png`} alt="Gallery Image 3"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image4.png`} alt="Gallery Image 4"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image5.png`} alt="Gallery Image 5"/>
//           </div>
//         </div>
//       </section>

//       <section className="gallery2">
//         {/* <div className="animated-bggii">
//             <div className="circlesgii circles1gii"></div>
//         </div> */}
//         <div className="gallery-container2">
//           <div className="gallery-track2">
//             <img src={`${process.env.PUBLIC_URL}/images/image6.png`} alt="Gallery Image 6"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image7.png`} alt="Gallery Image 7"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image8.png`} alt="Gallery Image 8"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image9.png`} alt="Gallery Image 9"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image10.png`} alt="Gallery Image 10"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image11.png`} alt="Gallery Image 11"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image12.png`} alt="Gallery Image 12"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image6.png`} alt="Gallery Image 6"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image7.png`} alt="Gallery Image 7"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image8.png`} alt="Gallery Image 8"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image9.png`} alt="Gallery Image 9"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image10.png`} alt="Gallery Image 10"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image11.png`} alt="Gallery Image 11"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image12.png`} alt="Gallery Image 12"/>
//           </div>
//         </div>
//       </section>

//       {/* Types of Images We Work With Section */}
//       <section className="image-types">
//         {/* <div className="animated-bgit">
//             <div className="circleit circle1it"></div>
//             <div className="circleit circle2it"></div>
//             <div className="circleit circle3it"></div>
//             <div className="circleit circle4it"></div>
//             <div className="circleit circle5it"></div>
//             <div className="circlesit circles1it"></div>
//             <div className="circlessit circles2it"></div>
//         </div> */}
//         <h2>Visualization Made Easy </h2>
//         <div className="image-grid">
//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/livingroom1.jpg`} alt="Simple Room Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/livingroom.png`} alt="Simple Room After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>Revamp Your Space With A Click</h3>
//               <p>Imagine capturing a photo of your room and instantly exploring a world of design possibilities. At RevampSpaces, we bring your interiors to life with the power of AI. Simply upload an image of your space, and our advanced technology will generate stunning redesigns tailored to your preferred style—whether it's modern minimalism, cozy Scandinavian, or luxurious contemporary.</p>
//             </div>
//           </div>

//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/bathroom.jpg`} alt="Sketch Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/bathroom1.png`} alt="Sketch After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>From Sketch to Stunning Interior</h3>
//               <p>A simple sketch is all it takes to bring your vision to life. With RevampSpaces, transform hand-drawn layouts into beautifully designed interiors in seconds. Whether it's a rough outline or a detailed floor plan, our AI interprets your ideas and reimagines them in breathtaking styles.</p>
//             </div>
//           </div>

//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/tvpanel1.png`} alt="3D Model Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/tvpanel.png`} alt="3D Model After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>From 3D Model to Breathtaking Design</h3>
//               <p>Bring your 3D models to life with stunning interior designs. At RevampSpaces, our AI transforms basic 3D layouts into fully styled, photorealistic interiors. Simply upload your model, select a theme, and watch as your space evolves with elegance and precision.</p>
//             </div>
//           </div>

//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/emptyroom.png`} alt="Simple Room Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/emptyroom1.png`} alt="Simple Room After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>Turn bare walls into beautiful homes—one piece at a time.</h3>
//               <p>An empty room is a canvas full of possibilities. With RevampSpaces, effortlessly fill your space with carefully curated furniture and decor, perfectly tailored to your style. From sleek modern aesthetics to timeless classics, our AI places each piece with harmony and precision—transforming emptiness into elegance.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Do It Yourself */}
//       <div className="how-it-works">
//         {/* <div className="animated-bghiw">
//             <div className="circlehiw circle1hiw"></div>
//             <div className="circlehiw circle2hiw"></div>
//             <div className="circlehiw circle3hiw"></div>
//             <div className="circlehiw circle4hiw"></div>
//             <div className="circlehiw circle5hiw"></div>
//             <div className="circleshiw circles1hiw"></div>
//             <div className="circlesshiw circles2hiw"></div>
//         </div> */}
//         <h2>Do It Yourself</h2>
//         <div className="card-container">
//           <div className="card">
//             <h3>Step 1: Upload Your Room</h3>
//             <p>Simply upload a picture of your room, and we'll take care of the rest!</p>
//             <img src={`${process.env.PUBLIC_URL}/images/uploadicon.png`} alt="Upload Icon" className="before" />
//           </div>
//           <div className="card">
//             <h3>Step 2: Select Your Style</h3>
//             <p>Choose your favorite interior design style and let us create the perfect look for you.</p>
//             <img src={`${process.env.PUBLIC_URL}/images/styles.png`} alt="Style Selection" className="before" />
//             <img src={`${process.env.PUBLIC_URL}/images/rooms.png`} alt="Room Types" className="after" />
//           </div>
//           <div className="card">
//             <h3>Step 3: Receive Your Design</h3>
//             <p>Get your personalized design suggestions, ready to transform your space!</p>
//             <img src={`${process.env.PUBLIC_URL}/images/bedroom.png`} alt="Bedroom Design" className="after" />
//           </div>
//         </div>
//       </div>

//       <section className="upcoming-tools">
//         {/* <div className="animated-bgut">
//             <div className="circleut circle1ut"></div>
//             <div className="circleut circle2ut"></div>
//             <div className="circleut circle3ut"></div>
//             <div className="circleut circle4ut"></div>
//             <div className="circleut circle5ut"></div>
//             <div className="circlesut circles1ut"></div>
//             <div className="circlessut circles2ut"></div>
//         </div> */}
//         <h2>Upcoming Tools</h2>
//         <div className="card-container">
//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/2dfloorplan.png`} alt="Simple Room Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/3dfloorplan.jpg`} alt="Simple Room After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>From 2D Plans to 3D Spaces In Minutes</h3>
//               <h4>Visualize Before You Create.</h4>
//               <p>Transform your 2D floor plans into simple, structured 3D models with ease. At RevampSpaces, we bridge the gap between sketches and stunning interiors by generating basic 3D layouts that serve as the foundation for AI-powered design transformations.</p>
//             </div>
//           </div>

//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/theme1.png`} alt="Simple Room Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/theme2.png`} alt="Simple Room After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>Bespoke AI Models, Tailored to Your Vision</h3>
//               <h4>Your Style. Your AI. Your Legacy.</h4>
//               <p>At RevampSpaces, we offer an exclusive service for designers, brands, and artists looking to train AI models on their unique design styles. Whether you're an interior designer, an architect, or a creative visionary, our AI can learn from your work—capturing your signature aesthetic and transforming it into a tool that scales your creativity.</p>
//             </div>
//           </div>

//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/bedroom_chair0.png`} alt="Sketch Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/bedroom_chair2.png`} alt="Sketch After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>Experience the Future of Interior Shopping</h3>
//               <h4>See it. Style it. Shop it.</h4>
//               <p>At RevampSpaces, we're not just transforming interiors—we're revolutionizing the way you shop for furniture. Soon, our platform will evolve into a dynamic marketplace, where you can generate and visualize furniture from nearby stores directly in your space.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Pricing Section */}
//       {/* <section id="pricing" className="pricing"> */}
//       {/* <div className="animated-bgp">
//             <div className="circlessp circles2p"></div>
//         </div> */}
//         {/* <h2>Pricing</h2>
//         <div className="price-card">
//           <h3>Basic (5 credits)</h3>
//           <p>Free for 5 image generations</p>
//           <p>Get basic AI-generated designs.</p>
//           <p>Only image generations</p>
//           <div className="comingsoon">
//             <h3>Coming Soon</h3>
//           </div>
//         </div>
//         <div className="price-card">
//           <h3>Weekly</h3>
//           <p>600/week (150 credits) </p>
//           <p>For a week you can generate upto 150 images</p>
//           <p>Only image generations</p>
//           <div className="comingsoon">
//             <h3>Coming Soon</h3>
//           </div>
//         </div>
//         <div className="price-card">
//           <h3>Monthly</h3>
//           <p>2000/month (500 credits) </p>
//           <p>for a Month you can generate 500 images</p>
//           <p>Only image generations</p>
//           <div className="comingsoon">
//             <h3>Coming Soon</h3>
//           </div>
//         </div>
//         <div className="price-card">
//           <h3>Pro</h3>
//           <p>5000/month (1000 credits) </p>
//           <p>for a Month you can generate 1000 images</p>
//           <p>Access to all tools</p>
//           <div className="comingsoon">
//             <h3>Coming Soon</h3>
//           </div>
//         </div>
//       </section> */}

//       {/* FAQ Section */}
//       {/* <section id="faq" className="faq">
//       <div className="animated-bgfaq">
//             <div className="circlessfaq circles2faq"></div>
//         </div>
//         <h2>Frequently Asked Questions</h2>
//         <div className="faq-item">
//           <h3>How does it work?</h3>
//           <p>Upload a photo, select a style, and receive a design.</p>
//         </div>
//         <div className="faq-item">
//           <h3>Is it free to use?</h3>
//           <p>We offer a free basic version and a paid pro plan.</p>
//         </div>
//       </section> */}
//       <section id="faq" className="faq-section">
//   <h2>Frequently Asked Questions</h2>
//   <div className="faq-container">
//     <div className="faq-item">
//       <button className="faq-question">What is RevampSpaces?<span className="faq-icon">+</span></button>
//       <div className="faq-answer">
//         <p>RevampSpaces is an AI-powered interior design platform that helps you transform your rooms into beautifully designed spaces with just a few clicks.</p>
//       </div>
//     </div>

//     <div className="faq-item">
//       <button className="faq-question">How can RevampSpaces help my business?<span className="faq-icon">+</span></button>
//       <div className="faq-answer">
//         <p>Our platform enables interior designers, architects, and homeowners to visualize ideas instantly, helping professionals save time and boost creativity while improving client satisfaction.</p>
//       </div>
//     </div>

//     <div className="faq-item">
//       <button className="faq-question">How many products or tools does RevampSpaces offer?<span className="faq-icon">+</span></button>
//       <div className="faq-answer">
//         <p>We currently offer AI-powered image generation tools like Room Revamp, Inpainting, and Furnishing. More tools such as AI-trained design models and 3D visualization are coming soon.</p>
//       </div>
//     </div>
//   </div>
// </section>

      



//       {/* Contact Section */}
//       <section id="contact" className="contact">
//       {/* <div className="animated-bgc">
//         <div className="circlessc circles2c"></div>
//       </div> */}
//        <h2>Contact Us</h2>
//        <p>Email: revampspaces.in@gmail.com</p>
//         <div className="social-links">
//          <a href="https://www.instagram.com/revampspaces.in" target="_blank" rel="noopener noreferrer">
//           <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" className="social-icon" />
//          </a>
//         </div>
//       </section>

//       {/* Footer Section */}
//       <footer className="footer-section">
//   <div className="footer-content">
//     <div className="footer-about">
//       <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="RevampSpaces Logo" className="footer-logo" />
//       <p>We are building revolutionary software to help interior designers and homeowners visualize their creative design ideas with ease and accuracy.</p>
//       <div className="footer-socials">
//         <a href="https://www.instagram.com/revampspaces.in" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
//         <a href="#"><i className="fab fa-linkedin"></i></a>
//         <a href="#"><i className="fab fa-facebook"></i></a>
//         <a href="#"><i className="fab fa-youtube"></i></a>
//       </div>
//     </div>

//     <div className="footer-links">
//       <h4>Links</h4>
//       <ul>
//         <li><a href="/#home">Home</a></li>
//         <li><a href="/#about">About Us</a></li>
//         <li><Link to="/tools">Try Now</Link></li>
//         <li><a href="/#contact">Contact Us</a></li>
//         <li><Link to="/login">Log In</Link></li>
//       </ul>
//     </div>

//     <div className="footer-other">
//       <h4>Other</h4>
//       <ul>
//         <li><a href="#">Terms & Conditions</a></li>
//         <li><a href="#">Privacy Policy</a></li>
//         <li><a href="#">Refund Policy</a></li>
//         <li><a href="#">Shipping & Delivery</a></li>
//       </ul>
//     </div>

//     <div className="footer-contact">
//       <h4>Keep In Touch</h4>
//       {/* <p><strong>Office Address:</strong><br />East Delhi, New Delhi - 110092</p> */}
//       <p><strong>Contact Number:</strong><br />+91 7710036965</p>
//       <p><strong>Email Address:</strong><br /><a href="mailto:revampspaces.in@gmail.com">revampspaces.in@gmail.com</a></p>
//     </div>
//   </div>

//   <div className="footer-bottom">
//     <p>© 2025 RevampSpaces | AI-Powered Interior Design</p>
//   </div>

//   {/* Cookie Consent Bar */}
//   {/* <div className="cookie-consent">
//     <p>By clicking "Accept all cookies", you agree RevampSpaces can store cookies on your device and disclose information in accordance with our Privacy Policy.</p>
//     <div className="cookie-buttons">
//       <button className="accept">Accept all</button>
//       <button className="reject">Reject all</button>
//       <button className="manage">Manage preferences</button>
//     </div>
//   </div> */}
// </footer>
//     </div>
//   );
// }

// export default App;



import React, { useEffect, useRef, useState } from "react";
import { Routes, Route, Link } from "react-router-dom";
import MainPage from "./pages/MainPage";
import InpaintingPage from "./pages/inpaintingpage";
import FurnishingPage from "./pages/FurnishingPage";
import "./App1.css";
import Login from "./components/login";
import Signup from "./components/Signup";
import ExploreToolsPage from "./pages/ToolsSection";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Theme order: luxury (dark gold) → light → bold (navy)
const THEMES = ["luxury", "light", "bold"];
const THEME_LABELS = { luxury: "Luxury", light: "Light", bold: "Bold" };

function App() {
  const [menuActive, setMenuActive] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem("rs-theme") || "luxury");

  const cycleTheme = () => {
    const next = THEMES[(THEMES.indexOf(theme) + 1) % THEMES.length];
    setTheme(next);
    localStorage.setItem("rs-theme", next);
  };

  const toggleMenu = () => setMenuActive(!menuActive);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  useEffect(() => {
    const navbar = document.querySelector(".navbarhome");
    const handleScroll = () => {
      if (window.scrollY > 50) {
        navbar.classList.add("sticky");
      } else {
        navbar.classList.remove("sticky");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // FAQ accordion logic
  useEffect(() => {
    const items = document.querySelectorAll(".faq-item");
    items.forEach((item) => {
      const btn = item.querySelector(".faq-question");
      if (btn) {
        btn.onclick = () => {
          const isOpen = item.classList.contains("active");
          items.forEach((i) => i.classList.remove("active"));
          if (!isOpen) item.classList.add("active");
          // Re-sync ScrollTrigger so sections below the accordion
          // reflow into their correct trigger positions.
          ScrollTrigger.refresh();
        };
      }
    });
  });

  return (
    <Routes>
      <Route
        path="/"
        element={
          <div className="home-wrapper">
            <header className="navbarhome">
              <h1>
                <a href="/#home" className="logo">RevampSpaces</a>
              </h1>
              <div className={`navbar-links ${menuActive ? "active" : ""}`}>
                <a href="/#about" className="nav-link" onClick={() => setMenuActive(false)}>About Us</a>
                <a href="/#tools" className="nav-link" onClick={() => setMenuActive(false)}>Our Tools</a>
                <a href="/#contact" className="nav-link" onClick={() => setMenuActive(false)}>Contact Us</a>
                <Link to="/login" className="nav-link" onClick={() => setMenuActive(false)}>Login</Link>
                <button className="theme-toggle" onClick={cycleTheme} aria-label="Switch theme">
                  <span className="theme-icon">
                    {theme === "luxury" && "◑"}
                    {theme === "light" && "☀"}
                    {theme === "bold" && "◈"}
                  </span>
                  <span className="theme-label">{THEME_LABELS[theme]}</span>
                </button>
              </div>
              <div className={`hamburger ${menuActive ? "active" : ""}`} onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </header>
            <HomePage />
          </div>
        }
      />
      <Route path="/main" element={<MainPage />} />
      <Route path="/inpainting" element={<InpaintingPage />} />
      <Route path="/furnish" element={<FurnishingPage />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/tools" element={<ExploreToolsPage />} />
    </Routes>
  );
}

function HomePage() {
  const rootRef = useRef(null);

  useEffect(() => {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const ctx = gsap.context(() => {
      if (reduceMotion) return; // respect accessibility preference, skip all motion

      /* ── HERO: on-load entrance ───────────────────────────────── */
      gsap.timeline({ defaults: { ease: "power3.out" } })
        .from(".hero-eyebrow", { opacity: 0, y: 16, duration: 0.6 })
        .from(".hero-card h1", { opacity: 0, y: 24, duration: 0.7 }, "-=0.35")
        .from(".hero-card p", { opacity: 0, y: 20, duration: 0.6 }, "-=0.4")
        .from(".hero-card .cta-button", { opacity: 0, y: 16, scale: 0.96, duration: 0.5 }, "-=0.3");

      /* ── STATS BAR: count-up + reveal on scroll ───────────────── */
      gsap.utils.toArray(".stat-item").forEach((stat, i) => {
        const numEl = stat.querySelector(".stat-number");
        const rawText = numEl.textContent.trim();
        const numMatch = rawText.match(/[\d,]+/);

        gsap.from(stat, {
          opacity: 0,
          y: 24,
          duration: 0.6,
          delay: i * 0.08,
          ease: "power2.out",
          scrollTrigger: { trigger: ".stats-bar", start: "top 85%", once: true },
        });

        // Only count up stats that are actually numeric (10,000+) —
        // labels like "5 Tools", "3D", "Instant" stay static text.
        if (numMatch && numMatch[0].replace(/,/g, "").length >= 3) {
          const target = parseInt(numMatch[0].replace(/,/g, ""), 10);
          const suffix = rawText.replace(numMatch[0], "");
          const counter = { val: 0 };
          gsap.to(counter, {
            val: target,
            duration: 1.4,
            delay: i * 0.08 + 0.2,
            ease: "power1.out",
            scrollTrigger: { trigger: ".stats-bar", start: "top 85%", once: true },
            onUpdate: () => {
              numEl.textContent = Math.floor(counter.val).toLocaleString("en-US") + suffix;
            },
            onComplete: () => {
              numEl.textContent = target.toLocaleString("en-US") + suffix;
            },
          });
        }
      });

      /* ── GENERIC SCROLL-REVEAL ────────────────────────────────
         Any element with data-reveal fades + rises into place the
         first time it crosses 82% up the viewport. Stagger groups
         share a stagger value via data-reveal-group. */
      const groups = {};
      gsap.utils.toArray("[data-reveal]").forEach((el) => {
        const group = el.getAttribute("data-reveal-group");
        if (group) {
          groups[group] = groups[group] || [];
          groups[group].push(el);
        } else {
          gsap.from(el, {
            opacity: 0,
            y: 36,
            duration: 0.7,
            ease: "power2.out",
            scrollTrigger: { trigger: el, start: "top 85%", once: true },
          });
        }
      });
      Object.values(groups).forEach((els) => {
        gsap.from(els, {
          opacity: 0,
          y: 36,
          duration: 0.65,
          stagger: 0.12,
          ease: "power2.out",
          scrollTrigger: { trigger: els[0], start: "top 85%", once: true },
        });
      });

      /* ── SECTION HEADERS: eyebrow / title / subtitle stagger ──── */
      gsap.utils.toArray(".section-header").forEach((header) => {
        gsap.from(header.children, {
          opacity: 0,
          y: 20,
          duration: 0.6,
          stagger: 0.1,
          ease: "power2.out",
          scrollTrigger: { trigger: header, start: "top 85%", once: true },
        });
      });

      /* ── CARD HOVER MICRO-INTERACTIONS ────────────────────────── */
      gsap.utils.toArray(".card, .image-card").forEach((card) => {
        const tween = gsap.to(card, {
          y: -8,
          scale: 1.015,
          duration: 0.28,
          ease: "power2.out",
          paused: true,
        });
        card.addEventListener("mouseenter", () => tween.play());
        card.addEventListener("mouseleave", () => tween.reverse());
      });

      /* ── CTA BUTTON PRESS FEEDBACK ─────────────────────────────── */
      gsap.utils.toArray(".cta-button").forEach((btn) => {
        btn.addEventListener("mousedown", () => gsap.to(btn, { scale: 0.96, duration: 0.12 }));
        btn.addEventListener("mouseup", () => gsap.to(btn, { scale: 1, duration: 0.18 }));
        btn.addEventListener("mouseleave", () => gsap.to(btn, { scale: 1, duration: 0.18 }));
      });

      /* ── HIW STEP NUMBERS: subtle pop-in tied to card reveal ──── */
      gsap.utils.toArray(".hiw-card").forEach((card) => {
        const step = card.querySelector(".hiw-step");
        gsap.from(step, {
          opacity: 0,
          scale: 0.7,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: { trigger: card, start: "top 85%", once: true },
        });
      });
    }, rootRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="homepage" id="home" ref={rootRef}>

      {/* ── HERO ── */}
      <header
        className="hero"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/backimg2.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="hero-content">
          <div className="hero-card">
            <p className="hero-eyebrow">AI-Powered Interior Design & 3D Modeling</p>
            <h1>Revamp Your Space with AI</h1>
            <p>Transform your interiors effortlessly with AI-powered design tools and photorealistic 3D visualization.</p>
            <Link to="/login" className="cta-button">Get Started</Link>
          </div>
        </div>
      </header>

      {/* ── STATS BAR ── */}
      <div className="stats-bar">
        <div className="stat-item">
          <span className="stat-number">10,000+</span>
          <span className="stat-label">Designs Generated</span>
        </div>
        <div className="stat-divider" />
        <div className="stat-item">
          <span className="stat-number">5 Tools</span>
          <span className="stat-label">AI-Powered Features</span>
        </div>
        <div className="stat-divider" />
        <div className="stat-item">
          <span className="stat-number">3D</span>
          <span className="stat-label">Modeling & Visualization</span>
        </div>
        <div className="stat-divider" />
        <div className="stat-item">
          <span className="stat-number">Instant</span>
          <span className="stat-label">Results, Every Time</span>
        </div>
      </div>

      {/* ── WHY CHOOSE US ── */}
      <section className="why-choose-us">
        <div className="section-header">
          <p className="section-eyebrow">Why RevampSpaces</p>
          <h2>Why Choose RevampSpaces?</h2>
          <p className="section-subtitle">Intelligent. Seamless. Affordable. Your dream space is just a click away.</p>
        </div>
        <div className="card-container">
          <div className="card" data-reveal data-reveal-group="why-cards">
            <div className="card-icon">✦</div>
            <h3>AI-Powered Precision</h3>
            <p>Our advanced AI understands spatial aesthetics, color harmony, and design principles—delivering interiors that feel expertly curated. Every generated space is crafted with precision, ensuring a seamless blend of beauty and functionality.</p>
          </div>
          <div className="card" data-reveal data-reveal-group="why-cards">
            <div className="card-icon">⚡</div>
            <h3>Quick & Easy</h3>
            <p>No design expertise? No problem. Our platform is built for everyone—just upload, select, and transform. With an intuitive interface and smart automation, creating breathtaking interiors has never been easier.</p>
          </div>
          <div className="card" data-reveal data-reveal-group="why-cards">
            <div className="card-icon">◎</div>
            <h3>Budget-Friendly</h3>
            <p>Great design shouldn't come with a hefty price tag. Whether you're exploring concepts or finalizing a vision, RevampSpaces helps you achieve stunning interiors without overspending.</p>
          </div>
          <div className="card" data-reveal data-reveal-group="why-cards">
            <div className="card-icon">⬡</div>
            <h3>Any Input, Any Format</h3>
            <p>Photo, sketch, 3D model, or empty room — our AI reads them all. There's no "right way" to start; just upload what you have and let RevampSpaces handle the rest.</p>
          </div>
          <div className="card" data-reveal data-reveal-group="why-cards">
            <div className="card-icon">▢</div>
            <h3>2D to 3D, Instantly</h3>
            <p>Bridge the gap between flat floor plans and immersive spaces. Generate structured 3D layouts from simple 2D drawings as a foundation for full design visualization.</p>
          </div>
          <div className="card" data-reveal data-reveal-group="why-cards">
            <div className="card-icon">◈</div>
            <h3>Built to Scale With You</h3>
            <p>From a single homeowner revamp to a designer's full client pipeline, RevampSpaces grows with your needs — with bespoke AI models on the roadmap for studios and brands.</p>
          </div>
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section id="about" className="about-section">
        <div className="about-container">
          <div className="about-text" data-reveal>
            <p className="section-eyebrow">About Us</p>
            <h2>Designing the Future of Interiors</h2>
            <p>
              At <strong>RevampSpaces</strong>, we believe that interior design should be effortless,
              accessible, and inspiring. Our AI-powered platform transforms the way you design your space,
              allowing you to visualize stunning interiors with just a few clicks.
            </p>
            <p>
              Whether you're refreshing a single room or revamping your entire home,
              our intelligent tools generate personalized designs tailored to your style and preferences.
              From concept to photorealistic render — we make it simple.
            </p>
            <p>
              We serve homeowners, interior designers, architects, and real estate professionals who want to
              visualize ideas quickly, impress clients, and cut down on costly design revisions.
            </p>
            <Link to="/tools" className="cta-button" style={{ marginTop: "1.5rem", display: "inline-block" }}>
              Explore Our Tools
            </Link>
          </div>
          <div className="about-image" data-reveal>
            <video
              src={`${process.env.PUBLIC_URL}/videos/about.mp4`}
              autoPlay
              loop
              muted
              playsInline
              className="about-video"
            />
          </div>
        </div>
      </section>

      {/* ── WHO IT'S FOR ── */}
      <section className="who-its-for">
        <div className="section-header">
          <p className="section-eyebrow">Built For You</p>
          <h2>Who RevampSpaces Is For</h2>
          <p className="section-subtitle">Whether you're redesigning your own home or managing client work, RevampSpaces fits how you work.</p>
        </div>
        <div className="wif-grid">
          <div className="wif-card" data-reveal data-reveal-group="wif-cards">
            <span className="wif-tag">Homeowners</span>
            <h3>Design Your Own Space, No Experience Needed</h3>
            <p>You don't need a design degree to see your home transformed. Upload a photo and explore styles in minutes, not months.</p>
            <ul className="wif-list">
              <li>Visualize before you spend a single rupee on renovation</li>
              <li>Try modern, Scandinavian, industrial, and more — risk-free</li>
              <li>Furnish empty rooms with AI-curated decor recommendations</li>
              <li>Get inspiration boards you can take straight to a contractor</li>
            </ul>
          </div>
          <div className="wif-card" data-reveal data-reveal-group="wif-cards">
            <span className="wif-tag">Designers & Architects</span>
            <h3>Visualize Faster, Impress Clients Sooner</h3>
            <p>Cut down on revision cycles and present photorealistic concepts before you commit to a single material order.</p>
            <ul className="wif-list">
              <li>Turn 2D floor plans into 3D concepts in minutes</li>
              <li>Generate multiple style directions per client meeting</li>
              <li>Train bespoke AI models on your own signature aesthetic</li>
              <li>Win more pitches with renders that feel finished, not sketched</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ── GALLERY ── */}
      <section className="gallery">
        <div className="section-header">
          <p className="section-eyebrow">Our Work</p>
          <h2>Our Generated Images</h2>
          <p className="section-subtitle">Every image below was produced entirely by our AI — no photographers, no staging.</p>
        </div>
        <div className="gallery-container">
          <div className="gallery-track">
            {[1, 2, 3, 4, 5, 1, 2, 3, 4, 5].map((n, i) => (
              <img key={i} src={`${process.env.PUBLIC_URL}/images/image${n}.png`} alt={`Gallery Image ${n}`} />
            ))}
          </div>
        </div>
      </section>

      <section className="gallery2">
        <div className="gallery-container2">
          <div className="gallery-track2">
            {[6, 7, 8, 9, 10, 11, 12, 6, 7, 8, 9, 10, 11, 12].map((n, i) => (
              <img key={i} src={`${process.env.PUBLIC_URL}/images/image${n}.png`} alt={`Gallery Image ${n}`} />
            ))}
          </div>
        </div>
      </section>

      {/* ── WHAT WE DO ── */}
      <section id="tools" className="image-types">
        <div className="section-header">
          <p className="section-eyebrow">What We Do</p>
          <h2>Visualization Made Easy</h2>
          <p className="section-subtitle">Upload any kind of visual — a photo, a sketch, a 3D model — and our AI transforms it into a stunning interior design.</p>
        </div>
        <div className="image-grid">

          <div className="image-card" data-reveal>
            <div className="hover-image">
              <img src={`${process.env.PUBLIC_URL}/images/livingroom1.jpg`} alt="Room Before" className="before" />
              <img src={`${process.env.PUBLIC_URL}/images/livingroom.png`} alt="Room After" className="after" />
            </div>
            <div className="card-content">
              <h3>Revamp Your Space With A Click</h3>
              <p>Imagine capturing a photo of your room and instantly exploring a world of design possibilities. Simply upload an image of your space, and our advanced AI will generate stunning redesigns tailored to your preferred style—whether it's modern minimalism, cozy Scandinavian, or luxurious contemporary.</p>
            </div>
          </div>

          <div className="image-card" data-reveal>
            <div className="hover-image">
              <img src={`${process.env.PUBLIC_URL}/images/bathroom.jpg`} alt="Bathroom Before" className="before" />
              <img src={`${process.env.PUBLIC_URL}/images/bathroom1.png`} alt="Bathroom After" className="after" />
            </div>
            <div className="card-content">
              <h3>From Sketch to Stunning Interior</h3>
              <p>A simple sketch is all it takes to bring your vision to life. Transform hand-drawn layouts into beautifully designed interiors in seconds. Whether it's a rough outline or a detailed floor plan, our AI interprets your ideas and reimagines them in breathtaking styles.</p>
            </div>
          </div>

          <div className="image-card" data-reveal>
            <div className="hover-image">
              <img src={`${process.env.PUBLIC_URL}/images/tvpanel1.png`} alt="3D Model Before" className="before" />
              <img src={`${process.env.PUBLIC_URL}/images/tvpanel.png`} alt="3D Model After" className="after" />
            </div>
            <div className="card-content">
              <h3>From 3D Model to Breathtaking Design</h3>
              <p>Bring your 3D models to life with stunning interior designs. Our AI transforms basic 3D layouts into fully styled, photorealistic interiors. Simply upload your model, select a theme, and watch as your space evolves with elegance and precision.</p>
            </div>
          </div>

          <div className="image-card" data-reveal>
            <div className="hover-image">
              <img src={`${process.env.PUBLIC_URL}/images/emptyroom.png`} alt="Empty Room Before" className="before" />
              <img src={`${process.env.PUBLIC_URL}/images/emptyroom1.png`} alt="Empty Room After" className="after" />
            </div>
            <div className="card-content">
              <h3>Turn Bare Walls into Beautiful Homes</h3>
              <p>An empty room is a canvas full of possibilities. Effortlessly fill your space with carefully curated furniture and decor, perfectly tailored to your style. From sleek modern aesthetics to timeless classics, our AI places each piece with harmony and precision.</p>
            </div>
          </div>

        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <div className="how-it-works">
        <div className="section-header">
          <p className="section-eyebrow">The Process</p>
          <h2>Do It Yourself</h2>
          <p className="section-subtitle">Three simple steps to your dream interior.</p>
        </div>
        <div className="card-container hiw-cards">
          <div className="card hiw-card" data-reveal data-reveal-group="hiw-cards">
            <div className="hiw-step">01</div>
            <h3>Upload Your Room</h3>
            <p>Simply upload a picture of your room — a photo, a sketch, or a 3D model. Our AI supports all formats and handles the rest.</p>
            <img src={`${process.env.PUBLIC_URL}/images/uploadicon.png`} alt="Upload Icon" className="before" />
          </div>
          <div className="card hiw-card" data-reveal data-reveal-group="hiw-cards">
            <div className="hiw-step">02</div>
            <h3>Select Your Style</h3>
            <p>Choose your favorite interior design style from dozens of curated options — modern, minimalist, Scandinavian, industrial, and more.</p>
            <img src={`${process.env.PUBLIC_URL}/images/styles.png`} alt="Style Selection" className="before" />
            <img src={`${process.env.PUBLIC_URL}/images/rooms.png`} alt="Room Types" className="after" />
          </div>
          <div className="card hiw-card" data-reveal data-reveal-group="hiw-cards">
            <div className="hiw-step">03</div>
            <h3>Receive Your Design</h3>
            <p>Get your personalized photorealistic design in seconds — ready to share, download, or use as inspiration for your actual renovation.</p>
            <img src={`${process.env.PUBLIC_URL}/images/bedroom.png`} alt="Bedroom Design" className="after" />
          </div>
        </div>
      </div>

      {/* ── UPCOMING TOOLS ── */}
      <section className="upcoming-tools">
        <div className="section-header">
          <p className="section-eyebrow">Coming Soon</p>
          <h2>Upcoming Tools</h2>
          <p className="section-subtitle">We're constantly building. Here's what's next on our roadmap.</p>
        </div>
        <div className="card-container">

          <div className="image-card" data-reveal data-reveal-group="upcoming-cards">
            <div className="hover-image">
              <img src={`${process.env.PUBLIC_URL}/images/2dfloorplan.png`} alt="2D Floor Plan" className="before" />
              <img src={`${process.env.PUBLIC_URL}/images/3dfloorplan.jpg`} alt="3D Floor Plan" className="after" />
            </div>
            <div className="card-content">
              <h3>From 2D Plans to 3D Spaces In Minutes</h3>
              <h4>Visualize Before You Create.</h4>
              <p>Transform your 2D floor plans into simple, structured 3D models with ease. We bridge the gap between sketches and stunning interiors by generating basic 3D layouts that serve as the foundation for AI-powered design transformations.</p>
            </div>
          </div>

          <div className="image-card" data-reveal data-reveal-group="upcoming-cards">
            <div className="hover-image">
              <img src={`${process.env.PUBLIC_URL}/images/theme1.png`} alt="Custom AI Before" className="before" />
              <img src={`${process.env.PUBLIC_URL}/images/theme2.png`} alt="Custom AI After" className="after" />
            </div>
            <div className="card-content">
              <h3>Bespoke AI Models, Tailored to Your Vision</h3>
              <h4>Your Style. Your AI. Your Legacy.</h4>
              <p>We offer an exclusive service for designers, brands, and artists looking to train AI models on their unique design styles. Our AI can learn from your work—capturing your signature aesthetic and transforming it into a tool that scales your creativity.</p>
            </div>
          </div>

          <div className="image-card" data-reveal data-reveal-group="upcoming-cards">
            <div className="hover-image">
              <img src={`${process.env.PUBLIC_URL}/images/bedroom_chair0.png`} alt="Furniture Before" className="before" />
              <img src={`${process.env.PUBLIC_URL}/images/bedroom_chair2.png`} alt="Furniture After" className="after" />
            </div>
            <div className="card-content">
              <h3>Experience the Future of Interior Shopping</h3>
              <h4>See it. Style it. Shop it.</h4>
              <p>We're revolutionizing the way you shop for furniture. Soon, our platform will evolve into a dynamic marketplace where you can generate and visualize furniture from nearby stores directly in your space — before you buy.</p>
            </div>
          </div>

        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section className="testimonials">
        <div className="section-header">
          <p className="section-eyebrow">Trusted By</p>
          <h2>What People Are Saying</h2>
          <p className="section-subtitle">Homeowners and design professionals using RevampSpaces to visualize faster.</p>
        </div>
        <div className="testimonial-grid">
          <div className="testimonial-card" data-reveal data-reveal-group="testimonial-cards">
            <div className="testimonial-stars">★★★★★</div>
            <p className="testimonial-quote">I uploaded a photo of my empty living room and had three full design directions before dinner. It completely changed how I planned my renovation budget.</p>
            <div className="testimonial-author">
              <span className="testimonial-name">Ananya Rao</span>
              <span className="testimonial-role">Homeowner, Mumbai</span>
            </div>
          </div>
          <div className="testimonial-card" data-reveal data-reveal-group="testimonial-cards">
            <div className="testimonial-stars">★★★★★</div>
            <p className="testimonial-quote">As an interior designer, client revisions used to eat my week. Now I generate two or three styled concepts in a single meeting and let them choose on the spot.</p>
            <div className="testimonial-author">
              <span className="testimonial-name">Vikram Mehta</span>
              <span className="testimonial-role">Interior Designer</span>
            </div>
          </div>
          <div className="testimonial-card" data-reveal data-reveal-group="testimonial-cards">
            <div className="testimonial-stars">★★★★★</div>
            <p className="testimonial-quote">The 2D-to-3D tool saved us hours on early-stage client pitches. It's not a replacement for our process, but it makes the first conversation so much easier.</p>
            <div className="testimonial-author">
              <span className="testimonial-name">Priya Nair</span>
              <span className="testimonial-role">Architect</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section id="faq" className="faq-section">
        <div className="section-header">
          <p className="section-eyebrow">FAQ</p>
          <h2>Frequently Asked Questions</h2>
        </div>
        <div className="faq-container">

          <div className="faq-item" data-reveal data-reveal-group="faq-items">
            <button className="faq-question">What is RevampSpaces?<span className="faq-icon">+</span></button>
            <div className="faq-answer">
              <p>RevampSpaces is an AI-powered interior design and 3D modeling platform that helps homeowners, designers, and architects transform any space into a beautifully designed interior with just a few clicks.</p>
            </div>
          </div>

          <div className="faq-item" data-reveal data-reveal-group="faq-items">
            <button className="faq-question">What types of inputs does the AI accept?<span className="faq-icon">+</span></button>
            <div className="faq-answer">
              <p>Our AI accepts real room photos, hand-drawn sketches, 3D model renders, and empty room photos. Any visual of a space — regardless of format — can be transformed using our tools.</p>
            </div>
          </div>

          <div className="faq-item" data-reveal data-reveal-group="faq-items">
            <button className="faq-question">How can RevampSpaces help my business?<span className="faq-icon">+</span></button>
            <div className="faq-answer">
              <p>Our platform enables interior designers, architects, and real estate professionals to visualize ideas instantly, impress clients with photorealistic renders, save time on design revisions, and boost creative output.</p>
            </div>
          </div>

          <div className="faq-item" data-reveal data-reveal-group="faq-items">
            <button className="faq-question">How many tools does RevampSpaces currently offer?<span className="faq-icon">+</span></button>
            <div className="faq-answer">
              <p>We currently offer Room Revamp (full room redesign), Inpainting (edit specific areas), and AI Furnishing. Upcoming tools include 2D-to-3D floor plan conversion, custom AI model training, and an integrated furniture marketplace.</p>
            </div>
          </div>

          <div className="faq-item" data-reveal data-reveal-group="faq-items">
            <button className="faq-question">Is RevampSpaces free to use?<span className="faq-icon">+</span></button>
            <div className="faq-answer">
              <p>We offer a free starter plan with limited credits. Paid plans with higher generation limits and access to all tools are coming soon. Sign up now to lock in early access pricing.</p>
            </div>
          </div>

        </div>
      </section>

      {/* ── CONTACT ── */}
      <section id="contact" className="contact">
        <div className="section-header" data-reveal>
          <p className="section-eyebrow">Get In Touch</p>
          <h2>Contact Us</h2>
          <p className="section-subtitle">Questions about a tool, a project, or partnering with us? We'd love to hear from you.</p>
        </div>
        <div className="contact-grid">
          <div className="contact-info" data-reveal>
            <div className="contact-info-item">
              <span className="contact-info-label">Email</span>
              <span className="contact-info-value">
                <a href="mailto:revampspaces.in@gmail.com">revampspaces.in@gmail.com</a>
              </span>
            </div>
            <div className="contact-info-item">
              <span className="contact-info-label">Phone</span>
              <span className="contact-info-value">+91 7710036965</span>
            </div>
            <div className="contact-info-item">
              <span className="contact-info-label">Hours</span>
              <div className="contact-hours"><span>Mon – Fri</span><span>9:00 AM – 7:00 PM</span></div>
              <div className="contact-hours"><span>Saturday</span><span>10:00 AM – 4:00 PM</span></div>
            </div>
            <div className="contact-info-item">
              <span className="contact-info-label">Follow Us</span>
              <div className="social-links">
                <a href="https://www.instagram.com/revampspaces.in" target="_blank" rel="noopener noreferrer">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                    alt="Instagram"
                    className="social-icon"
                  />
                </a>
              </div>
            </div>
          </div>

          <form
            className="contact-form"
            data-reveal
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="form-row">
              <div className="form-field">
                <label htmlFor="contact-name">Name</label>
                <input id="contact-name" type="text" name="name" placeholder="Your name" required />
              </div>
              <div className="form-field">
                <label htmlFor="contact-email">Email</label>
                <input id="contact-email" type="email" name="email" placeholder="you@example.com" required />
              </div>
            </div>
            <div className="form-field">
              <label htmlFor="contact-subject">Subject</label>
              <input id="contact-subject" type="text" name="subject" placeholder="What's this about?" />
            </div>
            <div className="form-field">
              <label htmlFor="contact-message">Message</label>
              <textarea id="contact-message" name="message" placeholder="Tell us a bit about your project..." required />
            </div>
            <button type="submit" className="cta-button form-submit">Send Message</button>
          </form>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="footer-section">
        <div className="footer-content">

          <div className="footer-about">
            <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="RevampSpaces Logo" className="footer-logo" />
            <p>We are building revolutionary software to help interior designers and homeowners visualize their creative design ideas with ease and accuracy — powered by AI.</p>
            <div className="footer-socials">
              <a href="https://www.instagram.com/revampspaces.in" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
              <a href="#"><i className="fab fa-linkedin"></i></a>
              <a href="#"><i className="fab fa-facebook"></i></a>
              <a href="#"><i className="fab fa-youtube"></i></a>
            </div>
          </div>

          <div className="footer-links">
            <h4>Links</h4>
            <ul>
              <li><a href="/#home">Home</a></li>
              <li><a href="/#about">About Us</a></li>
              <li><a href="/#tools">Our Tools</a></li>
              <li><Link to="/tools">Try Now</Link></li>
              <li><a href="/#contact">Contact Us</a></li>
              <li><Link to="/login">Log In</Link></li>
            </ul>
          </div>

          <div className="footer-other">
            <h4>Other</h4>
            <ul>
              <li><a href="#">Terms &amp; Conditions</a></li>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Refund Policy</a></li>
              <li><a href="#">Shipping &amp; Delivery</a></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Keep In Touch</h4>
            <p><strong>Contact Number:</strong><br />+91 7710036965</p>
            <p><strong>Email Address:</strong><br /><a href="mailto:revampspaces.in@gmail.com">revampspaces.in@gmail.com</a></p>
          </div>

        </div>
        <div className="footer-bottom">
          <p>© 2025 RevampSpaces | AI-Powered Interior Design</p>
        </div>
      </footer>

    </div>
  );
}

export default App;